module.exports = __webpack_public_path__ + "static/integrations-lawyers-177642442986f8fff17b740b31449bbb.png";